/**
 * "Step-up & action safety" — Auth section (ADR-0074).
 * Reconciled from logic/action-mode/action-mode.ts (read / safe-write /
 * destructive policy, undo windows, destructive-off-by-default) + the widget
 * step-up + act-on-behalf consent surfaces.
 */
import type { DocPageContent } from '../types';

export const AUTH_STEP_UP_PAGE: DocPageContent = {
  slug: 'auth/step-up',
  titleKey: 'docs.auth.stepUp.title',
  descriptionKey: 'docs.auth.stepUp.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.auth.stepUp.lead' },

    { kind: 'heading', level: 2, id: 'modes', textKey: 'docs.auth.stepUp.modes.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.stepUp.modes.body' },
    {
      kind: 'definitions',
      items: [
        { termKey: 'docs.auth.stepUp.mode.read.term', descKey: 'docs.auth.stepUp.mode.read.desc' },
        {
          termKey: 'docs.auth.stepUp.mode.safeWrite.term',
          descKey: 'docs.auth.stepUp.mode.safeWrite.desc',
        },
        {
          termKey: 'docs.auth.stepUp.mode.destructive.term',
          descKey: 'docs.auth.stepUp.mode.destructive.desc',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'destructive',
      textKey: 'docs.auth.stepUp.destructive.heading',
    },
    { kind: 'paragraph', textKey: 'docs.auth.stepUp.destructive.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.auth.stepUp.optIn.title',
      textKey: 'docs.auth.stepUp.optIn.body',
    },

    { kind: 'heading', level: 2, id: 'step-up', textKey: 'docs.auth.stepUp.flow.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.stepUp.flow.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.auth.stepUp.step.pause.title',
          textKey: 'docs.auth.stepUp.step.pause.text',
        },
        {
          titleKey: 'docs.auth.stepUp.step.verify.title',
          textKey: 'docs.auth.stepUp.step.verify.text',
        },
        {
          titleKey: 'docs.auth.stepUp.step.confirm.title',
          textKey: 'docs.auth.stepUp.step.confirm.text',
        },
        {
          titleKey: 'docs.auth.stepUp.step.undo.title',
          textKey: 'docs.auth.stepUp.step.undo.text',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'consent', textKey: 'docs.auth.stepUp.consent.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.stepUp.consent.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.auth.stepUp.rollout.title',
      textKey: 'docs.auth.stepUp.rollout.body',
      links: {
        trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.auth.stepUp.next.concept.title',
          textKey: 'docs.auth.stepUp.next.concept.text',
          to: { docSlug: 'confirmation' },
        },
        {
          titleKey: 'docs.auth.stepUp.next.providers.title',
          textKey: 'docs.auth.stepUp.next.providers.text',
          to: { docSlug: 'auth/identity-providers' },
        },
      ],
    },
  ],
};
